<section>
  <language-experties></language-experties>
  <language-learner-features></language-learner-features>
  <!-- <journey-with-language-learner></journey-with-language-learner> -->
  <app-science-behind-language-learner></app-science-behind-language-learner>
  <!-- <app-professionals-for-language-learner></app-professionals-for-language-learner> -->
</section>